import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, X } from 'lucide-react';

interface FloatingCTAProps { onClick: () => void; }

const FloatingCTA: React.FC<FloatingCTAProps> = ({ onClick }) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const nearBottom = window.innerHeight + window.scrollY > document.documentElement.scrollHeight - 400;
      setIsVisible(window.scrollY > 300 && !nearBottom);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return <AnimatePresence>{isVisible && <motion.div drag dragMomentum={false} dragElastic={0.1} onDragStart={() => setIsDragging(true)} onDragEnd={() => setIsDragging(false)} initial={{ opacity: 0, scale: 0.8, y: 20 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0.8, y: 20 }} className={`fixed bottom-24 right-6 z-40 ${isDragging ? 'cursor-grabbing' : 'cursor-grab'}`}>
    <div className="relative">
      <motion.button whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} onClick={(event) => { if (!isDragging) { event.stopPropagation(); onClick(); } }} className="group bg-forest-200 text-cream-50 w-14 h-14 sm:w-auto sm:h-auto sm:px-6 sm:py-4 rounded-full shadow-card hover:shadow-glow-lg transition-all duration-300 flex items-center justify-center sm:space-x-3 font-medium relative">
        <span className="hidden sm:inline">{t('cta.floating')}</span>
        <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" aria-hidden="true" />
      </motion.button>
      <motion.button type="button" whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }} onClick={(event) => { event.stopPropagation(); setIsVisible(false); }} aria-label="Masquer le bouton de contact" className="absolute -top-2 -right-2 flex h-6 w-6 items-center justify-center rounded-full bg-red-500 text-white transition-colors hover:bg-red-600"><X className="h-3.5 w-3.5" aria-hidden="true" /></motion.button>
    </div>
  </motion.div>}</AnimatePresence>;
};

export default FloatingCTA;
